import { z } from "zod";
import { ROLES } from "../enums.js";
export const RolSchema = z.enum(ROLES);
export const UsuarioPublicoSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string().min(1),
    // Nombre de usuario para iniciar sesión (no es secreto; la contraseña/PIN sí).
    usuario: z.string().min(1),
    rol: RolSchema,
    activo: z.boolean(),
});
// Lo que ve el admin en /admin/usuarios (incluye preferencias de notificación).
export const UsuarioAdminSchema = UsuarioPublicoSchema.extend({
    notificarDomicilios: z.boolean(),
    notificarSolicitudesQr: z.boolean(),
    // Pagos bancarios (Nequi/Bancolombia/DaviPlata): solo ADMIN por defecto —
    // el admin autoriza explícitamente a alguien más (p.ej. un cajero) desde
    // Usuarios si quiere que también le lleguen.
    notificarPagosBancarios: z.boolean(),
    // Aviso cuando una mesera intenta entrar desde un dispositivo/IP nuevo.
    notificarDispositivosMesera: z.boolean(),
    // CAJERO restringido a solo cobrar mesas + abrir/cerrar caja (sin venta
    // rápida ni tomar pedidos). No aplica a ADMIN/MESERA.
    soloCobroYCaja: z.boolean(),
    totpHabilitado: z.boolean(),
    creadoEn: z.string(),
});
export const CrearUsuarioSchema = z
    .object({
    nombre: z.string().min(1, "El nombre es obligatorio").max(100),
    usuario: z
        .string()
        .min(3, "El usuario debe tener al menos 3 caracteres")
        .max(60)
        .regex(/^[a-z0-9._-]+$/i, "Solo letras, números, punto, guion y guion bajo"),
    rol: RolSchema,
    // ADMIN/CAJERO inician con usuario+contraseña; MESERA con PIN de 4 dígitos.
    password: z.string().min(8, "La contraseña debe tener al menos 8 caracteres").optional(),
    pin: z.string().regex(/^\d{4}$/, "El PIN debe ser de 4 dígitos").optional(),
    notificarDomicilios: z.boolean().default(false),
    notificarSolicitudesQr: z.boolean().default(false),
    notificarPagosBancarios: z.boolean().optional(),
    notificarDispositivosMesera: z.boolean().optional(),
    soloCobroYCaja: z.boolean().optional(),
})
    .refine((data) => (data.rol === "MESERA" ? !!data.pin : !!data.password), {
    message: "Las meseras necesitan PIN de 4 dígitos; los demás roles necesitan contraseña.",
    path: ["password"],
});
export const EditarUsuarioSchema = z.object({
    nombre: z.string().min(1).max(100).optional(),
    rol: RolSchema.optional(),
    activo: z.boolean().optional(),
    notificarDomicilios: z.boolean().optional(),
    notificarSolicitudesQr: z.boolean().optional(),
    notificarPagosBancarios: z.boolean().optional(),
    notificarDispositivosMesera: z.boolean().optional(),
    soloCobroYCaja: z.boolean().optional(),
    // Si vienen, resetean la credencial de acceso (no se puede leer la actual).
    nuevaPassword: z.string().min(8).optional(),
    nuevoPin: z.string().regex(/^\d{4}$/).optional(),
});
//# sourceMappingURL=usuario.schema.js.map